import DefectsChurnChart from "../../components/charts/defectsCharts/DefectsChurnChart";
import DefectsSeverityChart from "../../components/charts/defectsCharts/DefectsSeverityChart";
import OpenClosedDefectsChart from "../../components/charts/defectsCharts/OpenClosedDefectsChart";
import QADefectsFoundCurrentRelease from "../../components/charts/defectsCharts/QADefectsFoundInCurrentRelease";
import DefectsvsReleaseItemsChart from "../../components/charts/defectsCharts/DefectsVsReleaseItemsChart";
import TargetedOpenDefectsBySprintChart from "../../components/charts/defectsCharts/TargetedOpenDefectsBySprintChart";
import ItemsWithResolvedStatusChart from "../../components/charts/defectsCharts/ItemsWithResolvedStatusChart";
import ResolvedAndAssignedItemsChart from "../../components/charts/defectsCharts/ResolvedAndAssignedItemsChart";

const DataSource = {
  JIRA: "JIRA",
  ADO: "ADO",
  QTEST: "qTest",
};

const DefectsProgramHealth = ({
  isADO,
  jiraChartsInfo,
  currentIteration,
  currentProjectId,
  setModalData,
  setShowModal,
  projectTestSource,
}) => {
  return (
    <div className="row ms-3 mt-5 row-cols-auto justify-content-around">
      <div id="defectsChurnChart" className="col col-5 mb-4">
        <div id="defects-churn-chart-root">
          <DefectsChurnChart
            isADO={isADO}
            jiraChartsInfo={jiraChartsInfo}
            currentProjectId={currentProjectId}
            currentIteration={currentIteration}
            setModalData={setModalData}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div id="defectsSeverityChart" className="col col-5 mb-4">
        <div id="defects-severity-chart-root">
          <DefectsSeverityChart
            isADO={isADO}
            jiraChartsInfo={jiraChartsInfo}
            currentProjectId={currentProjectId}
            currentIteration={currentIteration}
            setModalData={setModalData}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div id="openClosedDefectsChart" className="col col-5 mb-4">
        <div id="open-closed-defects-root">
          <OpenClosedDefectsChart
            isADO={isADO}
            jiraChartsInfo={jiraChartsInfo}
            currentProjectId={currentProjectId}
            currentIteration={currentIteration}
            setModalData={setModalData}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      {jiraChartsInfo && DataSource.ADO !== isADO && (
        <div
          id="qaDefectsFoundInCurrentReleaseChart"
          className="col col-5 mb-4"
        >
          <div id="qa-defects-found-current-release-chart-root">
            <QADefectsFoundCurrentRelease
              jiraChartsInfo={jiraChartsInfo}
              currentProjectId={currentProjectId}
              currentIteration={currentIteration}
              setModalData={setModalData}
              setShowModal={setShowModal}
            />
          </div>
        </div>
      )}
      <div id="defectsvsReleaseItems" className="col col-5 mb-4">
        <div id="defect-release-root">
          <DefectsvsReleaseItemsChart
            isADO={isADO}
            projectTestSource={projectTestSource}
            jiraChartsInfo={jiraChartsInfo}
            currentProjectId={currentProjectId}
            currentIteration={currentIteration}
            setModalData={setModalData}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div id="targetedOpenDefectsBySprint" className="col col-5 mb-4">
        <div id="defect-targeted-open-root">
          <TargetedOpenDefectsBySprintChart
            isADO={isADO}
            jiraChartsInfo={jiraChartsInfo}
            currentProjectId={currentProjectId}
            currentIteration={currentIteration}
            setModalData={setModalData}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div id="itemsWithResolvedStatusChart" className="col col-5 mb-4">
        <div id="items-with-resolved-status-chart-root">
          {jiraChartsInfo && (
            <ItemsWithResolvedStatusChart
              isADO={isADO}
              jiraChartsInfo={jiraChartsInfo}
              currentProjectId={currentProjectId}
              currentIteration={currentIteration}
              setModalData={setModalData}
              setShowModal={setShowModal}
            />
          )}
        </div>
      </div>
      <div id="resolvedAndAssignedItemsChart" className="col col-5 mb-4">
        <div id="resolved-and-assigned-items-chart-root">
          <ResolvedAndAssignedItemsChart
            isADO={isADO}
            jiraChartsInfo={jiraChartsInfo}
            currentProjectId={currentProjectId}
            currentIteration={currentIteration}
            setModalData={setModalData}
            setShowModal={setShowModal}
          />
        </div>
      </div>
    </div>
  );
};

export default DefectsProgramHealth;
